import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
// import { Place } from 'apollo/types';
// import useListPlacesQuery from 'apollo/resolvers/places/list';
import { Row, Col } from 'antd';
// import LoadingModal from 'components/generalUI/LoadingModal';
import styles from './Places.module.scss';
// import PlacesCards from './PlacesCards';
// import TricaoMap from './TricaoMap';

const Places: FC = () => {
  const { t } = useTranslation();

  // const { data, loading } = useListPlacesQuery();

  // const [places, setPlaces] = useState<Place[]>();

  // const sortPlacesWhereGrillIsThirdPlace = (placesToSort: Place[] | undefined) => {
  //   if (!placesToSort) {
  //     return [];
  //   }

  //   const sortedPlacesWhereGrillIsThird = [...placesToSort];

  //   const grillPlace = sortedPlacesWhereGrillIsThird.find(
  //     (place) => place.name === 'Quinchos'
  //   );

  //   const removedElement = sortedPlacesWhereGrillIsThird.splice(
  //     sortedPlacesWhereGrillIsThird.indexOf(grillPlace as Place),
  //     1
  //   );

  //   sortedPlacesWhereGrillIsThird.splice(2, 0, removedElement[0]);

  //   return sortedPlacesWhereGrillIsThird;
  // };

  // useEffect(() => {
  //   if (data) {
  //     setPlaces(data.listPlaces);
  //   }
  // }, [data]);

  return (
    <div id="places">
      {/* <LoadingModal visible={loading} /> */}
      <Row className={styles.Container}>
        <Col className={styles.InfoContainer} span={24}>
          <h1 className={styles.Title}>{t('pages.home.placesInfoTitle')}</h1>
        </Col>
        <Col span={24}>
          <iframe
            src="https://mybakerlab.com/tricao/"
            title="Tricao"
            className={styles.PlacesIframe}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Places;
